import { useState } from "react";
import { btnCancel, btnOne, inputStyleTwo, label, title } from "../utils/style";
import textValidator from "../helper_functions/textValidator";


function LeaveRequestForm({ setShowForm, submitHandler }) {
    const [ leaveData, setLeaveData ] = useState({})

    function updateLeaveData(e) {
        const { name, value } = e.target;
        if(name === 'date' && value.length > 10)  return
        const data = {...leaveData};
        data[name] = value;
        setLeaveData(data)
    }

    return(
        <div className="flex justify-center items-center bg-black bg-opacity-50  p-4 fixed top-0 left-0 h-screen w-screen">
            <div className="px-4 py-8 bg-white w-full rounded-lg shadow-xl">
                <div className="text-center"><span className={title}>Apply Leaves</span></div>
                <div className="py-2">
                    <label className={label}>Date</label>
                    <input className={inputStyleTwo} type="date" name='date' value={leaveData.date} onChange={e => updateLeaveData(e)}/>
                    <label className={label}>Leave Reason</label>
                    <input className={inputStyleTwo} name='reason' value={leaveData.reason} onChange={e => updateLeaveData(e)}/>
                </div>
                <div className="flex justify-between items-center gap-4 py-4">
                    <button className={btnCancel} onClick={() => setShowForm(false)}>Cancel</button>
                    <button onClick={() => submitHandler(leaveData)} className={btnOne}>Submit</button>
                </div>
            </div>
        </div>
    )
}

export default LeaveRequestForm;